import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { CRYPTO_SECRET_KEY, URLS, replaceNbsp } from "src/_config";
import parse from "html-react-parser";
import { useAppEvenListSelector, useAppRodeoEventSettingsSelector } from "src/_common/hooks/selectors/eventSelector";
import Sponsor from "src/components/common/Sponsor";
import { useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import Cryptr from "cryptr";
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function PrizeDetailsPage() {
  const { type, eventId, performanceId } = useParams<{ type?: string; eventId?: string; performanceId?: string }>();
  const eventApi = useEventApi();
  const toast = useToaster();
  const history = useHistory();
  const [prizes, setPrizes] = useState<Array<{
    id: number;
    content?: string;
    rodeo_event_dtls?: { title?: string };
    rodeo_event_event_id?: number;
    rodeo_event_event_dtls?: { event_name?: string };
  }> | null>(null);
  const rodeoEventSettings = useAppRodeoEventSettingsSelector() as { is_game_prize?: number; is_event_prize?: number } | null;
  const eventList = useAppEvenListSelector() as { list?: Array<{ id: string; login_required?: number }> } | null;
  const userDetails = useAppUserDetailsSelector();

  const gotoEventPage = () => {
    const e_id = cryptr.decrypt(eventId || '');
    const loginReq = eventList?.list?.find((x: { id: string; login_required?: number }) => x.id == e_id)?.login_required;
    if (userDetails || loginReq == 0) {
      history.push(`/event/${eventId}/${performanceId}`);
    } else {
      history.push(`${URLS.LOGIN}`);
    }
  };

  const getPrizeDetails = () => {
    const params: Record<string, unknown> = {
      type: cryptr.decrypt(type || '').toLowerCase(),
      game_id: cryptr.decrypt(eventId || ''),
    };
    if (performanceId && ["task", "performance"].includes(String(params.type))) {
      params["performance_id"] = cryptr.decrypt(performanceId);
    }
    eventApi.callPrizeDetails(
      params,
      (_message: string, resp: unknown) => {
        //console.log({resp})
        if (resp && typeof resp === "object" && "prizes" in resp) {
          setPrizes((resp as { prizes: Array<{ id: number }> }).prizes);
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  const goBack = () => {
    history.goBack();
  };

  useEffect(() => {
    // if (type && eventId) {
    getPrizeDetails();
    // }
    // }, [type, eventId]);
  }, []);

  return (
    <React.Fragment>
      <h2 className="page-title text-left">
        <a onClick={goBack} className="back-history">
          <img src="/images/left-white.svg" alt="back" />
        </a>
        {cryptr.decrypt(type)} Prize
        <hr className="color-white" />
      </h2>

      <div className="container">
        <div className="prizes-wrap">
          {prizes?.length ? (
            prizes.map((p) => (
              <div className="score-range-wrap back_sec" key={p.id}>
                <div className="contestants-wrap leaderboard-title">
                  <div className="contestants-title w-100">
                    {/* <h4>{p?.rodeo_event_dtls?.title}</h4> */}
                    <h4>
                      {cryptr.decrypt(type) == "Game"
                        ? p?.rodeo_event_dtls?.title
                        : p?.rodeo_event_event_id == -1
                        ? "All Tasks"
                        : p?.rodeo_event_event_dtls?.event_name}
                    </h4>
                  </div>
                </div>
                <ul className="performence-list cons-list-new">
                  <li className="selected">{parse(replaceNbsp(p.content || ""))}</li>
                </ul>
              </div>
            ))
          ) : (
            <ul className="performence-list cons-list-new">
              <li className="selected">No prize added yet</li>
            </ul>
          )}
        </div>
      </div>

      {rodeoEventSettings?.is_game_prize && !rodeoEventSettings?.is_event_prize && (
        <div className="join-now-btn-wrap">
          <button className="w-100" onClick={gotoEventPage}>
            Play Now
          </button>
        </div>
      )}

      <Sponsor />
    </React.Fragment>
  );
}
